<template>
  <div class="card-container">
    <common-top-form
     selectShowPower="/twohappyreturnmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/twohappyreturnmanage/add"
    >
 <el-form-item label="机构名称" prop="activityName"  v-if="this.textTatSimpleId">
         <el-select style="width: 198px" v-model="formModel.tatSimpleId" filterable>
                    <el-option
                        v-for="item in typeTwo"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
         <el-table-column
        prop="tatName"
        label="机构名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="number"
        label="第几返"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
        <!-- <el-table-column
        prop="tatMoney"
        label="机构利润"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column> -->
      <!-- <el-table-column
        prop="money"
        label="金额"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column
        prop="hhr1"
        label="一级"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hhr2"
        label="二级"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hhr3"
        label="三级"
        min-width="120"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        prop="integral"
        label="积分"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column
        prop="examineTransaction"
        label="达标交易量"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dayNuber"
        label="考核天数"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPerm('/twohappyreturnmanage/update')"
        label="操作"
        min-width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/twohappyreturnmanage/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label-width="137px" label="名称" prop="name"  v-if="!itemId">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.name"
          placeholder="请输入"
          style="width: 180px"
          
        ></el-input>
      </el-form-item>
       <el-form-item label-width="137px" label="名称" prop="name"  v-if="itemId">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.name"
          placeholder="请输入"
          style="width: 180px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label-width="137px" label="第几返" v-if="!itemId" prop="number">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.number"
          placeholder="请输入"
          style="width: 180px"
          
        ></el-input>
      </el-form-item>
        <el-form-item label-width="137px" label="第几返" v-if="itemId">
        <el-input
          type="number"
          maxlength="20"
          v-model="dialogModel.number"
          placeholder="请输入"
          style="width: 180px"
          disabled
        ></el-input>
      </el-form-item>
        <el-form-item label="机构名称" prop="tatSimpleId" v-if="!itemId">
                <el-select style="width: 198px" v-model="dialogModel.tatSimpleId">
                    <el-option
                        v-for="item in typeThree"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
              <el-form-item label="机构名称" prop="tatSimpleId" v-if="itemId">
                <el-select style="width: 198px" v-model="dialogModel.tatSimpleId" filterable>
                    <el-option
                        v-for="item in typeThree"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                        disabled
                    >
                    </el-option>
                </el-select>
            </el-form-item>
      <!-- <el-form-item label-width="137px" label="金额" prop="money">
        <el-input-number
          v-model="dialogModel.money"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
       <el-form-item label-width="137px" label="机构利润" prop="tatMoney">
        <el-input-number
          v-model="dialogModel.tatMoney"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="137px" label="积分" prop="integral">
        <el-input-number
          v-model="dialogModel.integral"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item> -->
      <el-form-item label-width="137px" label="一级(元)" prop="hhr1">
        <el-input-number
          v-model="dialogModel.hhr1"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="137px" label="二级(元)" prop="hhr2">
        <el-input-number
          v-model="dialogModel.hhr2"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="137px" label="三级(元)" prop="hhr3">
        <el-input-number
          v-model="dialogModel.hhr3"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <!-- <el-form-item
        label-width="137px"
        label="启用自定义考核"
        prop="enableCustomAssessment"
      >
        <el-switch
          v-model="dialogModel.enableCustomAssessment"
          active-value="1"
          inactive-value="0"
        >
        </el-switch>
      </el-form-item> -->
      <el-form-item
        label-width="137px"
        label="达标交易量"
        prop="examineTransaction"
      >
        <el-input-number
          v-model="dialogModel.examineTransaction"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="137px" label="考核天数" prop="dayNuber">
        <el-input-number
          v-model="dialogModel.dayNuber"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import TransactionService from "service/TransactionService";
import activity from "service/Ainstitution";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "twohappyreturnmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      showAdd: false,
      show: false,
      formModel: {
        tatSimpleId:""
      },
      tableData: [],
      submitService: TransactionService.threehappyreturnmanageList,
      itemId: "",
      dialogModel: {
        name: "",
         tatSimpleId: undefined,
        number: undefined,
        money: undefined,
        tatMoney: '',
        hhr1: undefined,
        hhr2: undefined,
        hhr3: undefined,
        integral: undefined,
        examineTransaction: undefined,
        enableCustomAssessment: "0",
        dayNuber: undefined,
      },
      dialogRules: {
         name: [
          {
            required: true,
            message: "请输入",
          },
        ],
          number: [
          {
            required: true,
            message: "请输入",
          },
        ],
         tatSimpleId: [
          {
            required: true,
            message: "请输入",
          },
        ],
          tatMoney: [
          {
            required: true,
            message: "请输入",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入",
          },
        ],
        integral: [
          {
            required: true,
            message: "请输入",
          },
        ],
        hhr1: [
          {
            required: true,
            message: "请输入",
          },
        ],
        hhr2: [
          {
            required: true,
            message: "请输入",
          },
        ],
        hhr3: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
         typeTwo: [{ tatName: "全部", id: "" }],
         typeThree: []
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {

    this.load();
  },
  computed: {
    addButton() {
      if(this.showAdd) {
        return '/twohappyreturnmanage/add'
      } 
    },
    submitData() {
      const params = {}
       if(this.textTatSimpleId) {
        params.tatSimpleId = this.formModel.tatSimpleId
      }
     
      return params;
    },
    dialogData() {
      const params = {
        tatSimpleId: this.dialogModel.tatSimpleId,
         name: this.dialogModel.name,
          number: this.dialogModel.number,
        // money: this.dialogModel.money * 100,
        hhr1: this.dialogModel.hhr1 * 100,
        hhr2: this.dialogModel.hhr2 * 100,
        hhr3: this.dialogModel.hhr3 * 100,
        // tatMoney: this.dialogModel.tatMoney * 100,
        // integral: this.dialogModel.integral,
        // enableCustomAssessment: this.dialogModel.enableCustomAssessment,
        examineTransaction: this.dialogModel.examineTransaction,
        dayNuber: this.dialogModel.dayNuber,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
    
      console.log(this.itemId,'wwwwwwwwwwwwwww')
      return this.itemId
        ? TransactionService.threehappyreturnmanageEdit
        : TransactionService.threehappyreturnmanageAdd;
 
    },
    ...mapGetters(["serverType", "tatId", "userId",'textTatSimpleId']),
  },
  watch: {},
  methods: {
     getTypeTwo() {
        this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows,'res1')
            res.contents.rows.forEach(item => {
              item.dictValue = item.id,
              item.dictKey = item.tatName
            })
             this.typeTwo = [...this.typeTwo,...res.contents.rows];
             this.typeThree = [...this.typeThree,...res.contents.rows]
          });
        },
        "信息获取失败"
      );
    },
    load() {
      this.showAdd = this.textTatSimpleId
      console.log(this.textTatSimpleId,'this.textTatSimpleId')
      this.formModel = {
        tatSimpleId: ''
      };
      this.getList();
        this.getTypeTwo();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res,'res')
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        TransactionService.threehappyreturnmanageStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.money = this.dialogModel.money / 100;
        this.dialogModel.tatMoney = this.dialogModel.tatMoney / 100;
        this.dialogModel.hhr1 = this.dialogModel.hhr1 / 100;
        this.dialogModel.hhr2 = this.dialogModel.hhr2 / 100;
        this.dialogModel.hhr3 = this.dialogModel.hhr3 / 100;
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        tatSimpleId: undefined,
        name: "",
        number: undefined,
        money: undefined,
        tatMoney: undefined,
        hhr1: undefined,
        hhr2: undefined,
        hhr3: undefined,
        integral: undefined,
        enableCustomAssessment: "0",
        examineTransaction: undefined,
        dayNuber: undefined,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      console.log(res,'res')
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        console.log(this.tableData,'wwww')
      });
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/TwoHappyReturnManage.vue